export default "/USDT.d40b0edab585db155037c5a5ba66c31c.svg";